import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { AngularSplitModule } from 'angular-split';

import { DirectivesModule } from '../directives/directives.module';
import { CustomFormsModule } from '../modules/custom-forms/custom-forms.module';
import { MdePopoverModule } from '../modules/popover/popover.module';
import { PipesModule } from '../pipes/pipes.module';
import { BasePointSelectComponent } from './base-point-select/base-point-select.component';
import { BasePointThumbnailComponent } from './base-point-thumbnail/base-point-thumbnail.component';
import { CuttingFurnitureBaseDialogComponent } from './cutting-furniture-base-dialog/cutting-furniture-base-dialog.component';
import { GroupMaterialDiscountTreeComponent } from './cutting-group-material-discount-tree/cutting-group-material-discount-tree.component';
import { GroupMaterialTreeComponent } from './cutting-group-material-tree/cutting-group-material-tree.component';
import { GroupMaterialDiscountTreeDialogComponent } from './group-material-discount-tree-dialog/group-material-discount-tree-dialog.component';
import { ImageViewerComponent } from './image-viewer/image-viewer.component';
import { ManyButtInColorBottomSheetComponent } from './many-butt-in-color-bottom-sheet/many-butt-in-color-bottom-sheet.component';
import { MaterialGroupsDialogComponent } from './material-groups-dialog/material-groups-dialog.component';
import { MaterialGroupsComponent } from './material-groups/material-groups.component';
import { PanelsSchemaDialogComponent } from './panels-schema-dialog/panels-schema-dialog.component';
import { FocusableElementComponent } from './panels-schema/focusable-element/focusable-element.component';
import { PanelsSchemaComponent } from './panels-schema/panels-schema.component';
import { SvgWorkspaceComponent } from './svg-workspace/svg-workspace.component';

const COMPONENTS: Type<any>[] = [
  ImageViewerComponent,
  SvgWorkspaceComponent,
  PanelsSchemaComponent,
  PanelsSchemaDialogComponent,
  FocusableElementComponent,
  GroupMaterialTreeComponent,
  CuttingFurnitureBaseDialogComponent,
  BasePointSelectComponent,
  BasePointThumbnailComponent,
  ManyButtInColorBottomSheetComponent,
  GroupMaterialDiscountTreeComponent,
  GroupMaterialDiscountTreeDialogComponent,
  MaterialGroupsDialogComponent,
  MaterialGroupsComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    CustomFormsModule,

    AngularSplitModule,

    DirectivesModule,

    MdePopoverModule,

    MatIconModule, //
    MatExpansionModule,
    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    CdkTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatMenuModule,
    MatDialogModule,
    MatSortModule,
    MatRippleModule,
    MatDividerModule,
    MatToolbarModule,
    MatCardModule,
    MatBottomSheetModule,
    MatProgressSpinnerModule,
    MatTreeModule,
    MatListModule,
    MatRadioModule,
    PipesModule,
  ],
  declarations: [COMPONENTS],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [MdePopoverModule, MatListModule, CustomFormsModule, COMPONENTS],
})
export class ComponentsModule {}
